import { UpdateContract } from "../features/contract/update-contract/update-contract";

const Updatecontractsolicitor = () => {
    return <UpdateContract />
}

export default Updatecontractsolicitor;